import { render, staticRenderFns } from "./FormCenterSetHowen.vue?vue&type=template&id=8364b04e&scoped=true&"
import script from "./FormCenterSetHowen.vue?vue&type=script&lang=ts&"
export * from "./FormCenterSetHowen.vue?vue&type=script&lang=ts&"
import style0 from "./FormCenterSetHowen.vue?vue&type=style&index=0&id=8364b04e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8364b04e",
  null
  
)

export default component.exports